import { useEffect } from "react";
import { useLocalStorage } from "./useWebStorage";
import useAsync from "./useAsync";
import { getLocalMedia } from "../webtrc/local-media";

export function useSelectedMediaDevice(kind: MediaDeviceKind) {
  return useLocalStorage<MediaDeviceInfo | null>("_mediaDevice:" + kind, null);
}

let localPromise: Promise<MediaDeviceInfo[]> | null = null;

export default function useMediaDeviceSelector(kind: MediaDeviceKind) {
  const [selected, setSelected, getSelected] = useSelectedMediaDevice(kind);
  const { error, status, data, run } = useAsync<MediaDeviceInfo[] | null>();
  useEffect(() => {
    const updateDevices = () => {
      if (!localPromise) {
        localPromise = getLocalMedia().then((s) => {
          return navigator.mediaDevices.enumerateDevices().then((devices) => {
            if (
              getSelected()?.deviceId &&
              !devices.some((d) => d.deviceId === getSelected()?.deviceId)
            ) {
              // We can't find it any longer
              setSelected(null);
            }
            setTimeout(() => {
              s.getTracks().forEach((t) => t.stop());
            }, 100);
            return devices;
          });
        });
      }
      return run(
        localPromise.then((devices) => devices.filter((d) => d.kind === kind))
      );
    };
    updateDevices();
    const deviceChangeListener = () => {
      localPromise = null;
      updateDevices();
    };
    navigator.mediaDevices.addEventListener(
      "devicechange",
      deviceChangeListener
    );
    return () => {
      navigator.mediaDevices.removeEventListener(
        "devicechange",
        deviceChangeListener
      );
    };
  }, [kind]);
  return {
    selected,
    setSelected,
    error,
    status,
    devices: data
  };
}
